import { Collapse } from "antd";
import { useSelector } from "react-redux";

import { ReactComponent as ArrowUp } from "assets/icons/arrow-up.svg";
import { ReactComponent as ArrowDown } from "assets/icons/arrow-down.svg";
import { useTranslation } from "react-i18next";
import { ReactComponent as Warning } from "assets/icons/warning-blue-circule.svg";

const AmountCollapse = () => {
  const { t } = useTranslation();
  const userPma = useSelector((state) => state?.pmaReducer?.userPma);

  const renderContent = () => {
    return [
      {
        key: 1,
        label: (
          <span className="flex items-center text-gray-4 body-14px-medium ">
            <Warning className="pl-2 w-7 h-7 [&>g>path]:fill-blue-0" />
            {t("pma-inventory-increase.help-payment")}
          </span>
        ),
        children: (
          <div>
            در انتهای فرایند پس از تکمیل مراحل پرداخت و تایید فیش، مبلغ از شما
            دریافت و در سبد {userPma?.plan_name} برای شما سرمایه‌گذاری می‌شود.
          </div>
        ),
      },
    ];
  };
  return (
    <Collapse
      defaultActiveKey={"1"}
      expandIcon={({ isActive }) =>
        isActive ? (
          <ArrowUp className="[&>path]:fill-gray--1" />
        ) : (
          <ArrowDown className="[&>path]:fill-gray--1" />
        )
      }
      expandIconPosition="end"
      accordion
      items={renderContent()}
      className="!border-none shadow-sm !bg-white mt-5"
    />
  );
};
export default AmountCollapse;
